import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const Shell = ({ children, back, className }) => (
  <div className="min-h-screen bg-[#F9F8F6] text-[#1C1C1C]">
    <header className="flex items-center justify-between px-6 py-6 md:px-12">
      <Link to="/" className="font-sans text-sm uppercase tracking-[0.4em]">
        Ruang Kenang
      </Link>
      {back && (
        <Link
          to={back.to}
          className="font-sans text-xs uppercase tracking-widest text-[#8A8A8A] hover:text-[#1C1C1C]"
        >
          {back.label}
        </Link>
      )}
    </header>
    <main className={cn("mx-auto w-full px-6 pb-24 md:px-12", className)}>
      {children}
    </main>
  </div>
);

export const Btn = ({ variant = "solid", className, ...p }) => (
  <button
    type="button"
    {...p}
    className={cn(
      "inline-flex items-center justify-center gap-2 px-8 py-4 font-sans text-sm uppercase tracking-widest transition-colors duration-300 disabled:cursor-not-allowed disabled:opacity-40",
      variant === "solid"
        ? "bg-[#1C1C1C] text-white hover:bg-[#333333]"
        : "border border-[#1C1C1C] bg-transparent text-[#1C1C1C] hover:bg-[#1C1C1C] hover:text-white",
      className
    )}
  />
);

export const Field = ({ label, hint, ...p }) => (
  <label className="block">
    <span className="font-sans text-xs uppercase tracking-wider text-[#8A8A8A]">
      {label}
    </span>
    <input
      {...p}
      className="mt-2 w-full border-0 border-b border-[#E8E3D9] bg-transparent py-3 font-sans text-base text-[#1C1C1C] outline-none transition-colors focus:border-[#1C1C1C]"
    />
    {hint && <span className="mt-2 block text-xs text-[#8A8A8A]">{hint}</span>}
  </label>
);

export const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    : "";

export const dateRange = (a) =>
  a.startDate === a.endDate || !a.endDate
    ? fmtDate(a.startDate)
    : `${fmtDate(a.startDate)} – ${fmtDate(a.endDate)}`;
